function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import EventManager from '@uppy/core/lib/EventManager.js';
import { RateLimitedQueue, internalRateLimitedQueue
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore untyped
} from '@uppy/utils/lib/RateLimitedQueue';
import NetworkError from '@uppy/utils/lib/NetworkError';
import isNetworkError from '@uppy/utils/lib/isNetworkError';
import { fetcher } from '@uppy/utils/lib/fetcher';
import { filterNonFailedFiles, filterFilesToEmitUploadStarted } from '@uppy/utils/lib/fileFilters';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.6.8"
};
import locale from "./locale.js";
function buildResponseError(xhr, err) {
  var error = err;
  // No error message
  if (!error) error = new Error('Upload error');
  // Got an error message string
  if (typeof error === 'string') error = new Error(error);
  // Got something else
  if (!(error instanceof Error)) {
    error = Object.assign(new Error('Upload error'), {
      data: error
    });
  }
  if (isNetworkError(xhr)) {
    error = new NetworkError(error, xhr);
    return error;
  }

  // @ts-expect-error request can only be set on NetworkError
  // but we use NetworkError to distinguish between errors.
  error.request = xhr;
  return error;
}

/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 */
function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}
var defaultOptions = {
  formData: true,
  fieldName: 'file',
  method: 'post',
  allowedMetaFields: null,
  responseUrlFieldName: 'url',
  bundle: false,
  headers: {},
  timeout: 30 * 1000,
  limit: 5,
  withCredentials: false,
  responseType: '',
  getResponseData: function getResponseData(responseText) {
    var parsedResponse = {};
    try {
      parsedResponse = JSON.parse(responseText);
    } catch (_unused) {
      // ignore
    }
    // We don't have access to the B (Body) generic here
    // so we have to cast it to any. The user facing types
    // remain correct, this is only to please the merging of default options.
    return parsedResponse;
  },
  getResponseError: function getResponseError(_, response) {
    var error = new Error('Upload error');
    if (isNetworkError(response)) {
      error = new NetworkError(error, response);
    }
    return error;
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
var _getFetcher = /*#__PURE__*/_classPrivateFieldLooseKey("getFetcher");
var _uploadLocalFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadLocalFile");
var _uploadBundle = /*#__PURE__*/_classPrivateFieldLooseKey("uploadBundle");
var _getCompanionClientArgs = /*#__PURE__*/_classPrivateFieldLooseKey("getCompanionClientArgs");
var _uploadFiles = /*#__PURE__*/_classPrivateFieldLooseKey("uploadFiles");
var _handleUpload = /*#__PURE__*/_classPrivateFieldLooseKey("handleUpload");
var XHRUpload = /*#__PURE__*/function (_BasePlugin) {
  _inherits(XHRUpload, _BasePlugin);
  function XHRUpload(uppy, _opts) {
    var _this;
    _classCallCheck(this, XHRUpload);
    _this = _callSuper(this, XHRUpload, [uppy, _objectSpread(_objectSpread({}, defaultOptions), {}, {
      fieldName: _opts.bundle ? 'files[]' : 'file'
    }, _opts)]);
    Object.defineProperty(_assertThisInitialized(_this), _uploadFiles, {
      value: _uploadFiles2
    });
    Object.defineProperty(_assertThisInitialized(_this), _getCompanionClientArgs, {
      value: _getCompanionClientArgs2
    });
    Object.defineProperty(_assertThisInitialized(_this), _uploadBundle, {
      value: _uploadBundle2
    });
    Object.defineProperty(_assertThisInitialized(_this), _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(_assertThisInitialized(_this), _getFetcher, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _handleUpload, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileIDs) {
          var files, filesFiltered, filesToEmit, isSomeFileRemote;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(fileIDs.length === 0)) {
                  _context.next = 3;
                  break;
                }
                _this.uppy.log('[XHRUpload] No files to upload!');
                return _context.abrupt("return");
              case 3:
                // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
                // (basically just AwsS3) using the internal symbol
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore untyped internal
                if (_this.opts.limit === 0 && !_this.opts[internalRateLimitedQueue]) {
                  _this.uppy.log('[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0', 'warning');
                }
                _this.uppy.log('[XHRUpload] Uploading...');
                files = _this.uppy.getFilesByIds(fileIDs);
                filesFiltered = filterNonFailedFiles(files);
                filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
                _this.uppy.emit('upload-start', filesToEmit);
                if (!_this.opts.bundle) {
                  _context.next = 19;
                  break;
                }
                // if bundle: true, we don’t support remote uploads
                isSomeFileRemote = filesFiltered.some(function (file) {
                  return file.isRemote;
                });
                if (!isSomeFileRemote) {
                  _context.next = 13;
                  break;
                }
                throw new Error('Can’t upload remote files when the `bundle: true` option is set');
              case 13:
                if (!(typeof _this.opts.headers === 'function')) {
                  _context.next = 15;
                  break;
                }
                throw new TypeError('`headers` may not be a function when the `bundle: true` option is set');
              case 15:
                _context.next = 17;
                return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uploadBundle)[_uploadBundle](filesFiltered);
              case 17:
                _context.next = 21;
                break;
              case 19:
                _context.next = 21;
                return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uploadFiles)[_uploadFiles](filesFiltered);
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function value(_x) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    _this.type = 'uploader';
    _this.id = _this.opts.id || 'XHRUpload';
    _this.defaultLocale = locale;
    _this.i18nInit();

    // Simultaneous upload limiting is shared across all uploads with this plugin.
    if (internalRateLimitedQueue in _this.opts) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore untyped internal
      _this.requests = _this.opts[internalRateLimitedQueue];
    } else {
      _this.requests = new RateLimitedQueue(_this.opts.limit);
    }
    if (_this.opts.bundle && !_this.opts.formData) {
      throw new Error('`opts.formData` must be true when `opts.bundle` is enabled.');
    }
    if (_this.opts.bundle && typeof _this.opts.headers === 'function') {
      throw new Error('`opts.headers` can not be a function when the `bundle: true` option is set.');
    }
    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && 'metaFields' in _this.opts) {
      throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
    }
    _this.uploaderEvents = Object.create(null);
    /**
     * xhr-upload wrapper for `fetcher` to handle user options
     * `validateStatus`, `getResponseError`, `getResponseData`
     * and to emit `upload-progress`, `upload-error`, and `upload-success` events.
     */
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getFetcher)[_getFetcher] = function (files) {
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
          var _options$method, res, body, uploadURL, _iterator2, _step2, file, request, customError, _iterator3, _step3, _file;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetcher(url, _objectSpread(_objectSpread({}, options), {}, {
                  method: options == null || (_options$method = options.method) == null ? void 0 : _options$method.toUpperCase(),
                  onTimeout: function onTimeout(timeout) {
                    var seconds = Math.ceil(timeout / 1000);
                    var error = new Error(_this.i18n('uploadStalled', {
                      seconds: seconds
                    }));
                    _this.uppy.emit('upload-stalled', error, files);
                  },
                  onUploadProgress: function onUploadProgress(event) {
                    if (event.lengthComputable) {
                      var _iterator = _createForOfIteratorHelper(files),
                        _step;
                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var file = _step.value;
                          _this.uppy.emit('upload-progress', file, {
                            // TODO: do not send `uploader` in next major
                            // @ts-expect-error we can't type this and we should remove it
                            uploader: _assertThisInitialized(_this),
                            bytesUploaded: event.loaded / event.total * file.size,
                            bytesTotal: file.size
                          });
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                    }
                  }
                }));
              case 3:
                res = _context2.sent;
                if (_this.opts.validateStatus(res.status, res.responseText, res)) {
                  _context2.next = 6;
                  break;
                }
                throw new NetworkError(res.statusText, res);
              case 6:
                body = _this.opts.getResponseData(res.responseText, res);
                uploadURL = body == null ? void 0 : body[_this.opts.responseUrlFieldName];
                _iterator2 = _createForOfIteratorHelper(files);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    file = _step2.value;
                    _this.uppy.emit('upload-success', file, {
                      status: res.status,
                      body: body,
                      uploadURL: uploadURL
                    });
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                return _context2.abrupt("return", res);
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                if (!(_context2.t0.name === 'AbortError')) {
                  _context2.next = 17;
                  break;
                }
                return _context2.abrupt("return", undefined);
              case 17:
                if (_context2.t0 instanceof NetworkError) {
                  request = _context2.t0.request;
                  customError = buildResponseError(request, _this.opts.getResponseError(request.responseText, request));
                  _iterator3 = _createForOfIteratorHelper(files);
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      _file = _step3.value;
                      _this.uppy.emit('upload-error', _file, customError);
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
                throw _context2.t0;
              case 19:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 13]]);
        }));
        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }();
    };
    return _this;
  }
  _createClass(XHRUpload, [{
    key: "getOptions",
    value: function getOptions(file) {
      var overrides = this.uppy.getState().xhrUpload;
      var headers = this.opts.headers;
      var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
        headers: {}
      });
      // Support for `headers` as a function, only in the XHRUpload settings.
      // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
      //
      // ```js
      // headers: (file) => ({ expires: file.meta.expires })
      // ```
      if (typeof headers === 'function') {
        opts.headers = headers(file);
      } else {
        Object.assign(opts.headers, this.opts.headers);
      }
      if (overrides) {
        Object.assign(opts.headers, overrides.headers);
      }
      if (file.xhrUpload) {
        Object.assign(opts.headers, file.xhrUpload.headers);
      }
      return opts;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "addMetadata",
    value: function addMetadata(formData, meta, opts) {
      var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta); // Send along all fields by default.

      allowedMetaFields.forEach(function (item) {
        var value = meta[item];
        if (Array.isArray(value)) {
          // In this case we don't transform `item` to add brackets, it's up to
          // the user to add the brackets so it won't be overridden.
          value.forEach(function (subItem) {
            return formData.append(item, subItem);
          });
        } else {
          formData.append(item, value);
        }
      });
    }
  }, {
    key: "createFormDataUpload",
    value: function createFormDataUpload(file, opts) {
      var formPost = new FormData();
      this.addMetadata(formPost, file.meta, opts);
      var dataWithUpdatedType = setTypeInBlob(file);
      if (file.name) {
        formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
      } else {
        formPost.append(opts.fieldName, dataWithUpdatedType);
      }
      return formPost;
    }
  }, {
    key: "createBundledUpload",
    value: function createBundledUpload(files, opts) {
      var _this2 = this;
      var formPost = new FormData();
      var _this$uppy$getState = this.uppy.getState(),
        meta = _this$uppy$getState.meta;
      this.addMetadata(formPost, meta, opts);
      files.forEach(function (file) {
        var options = _this2.getOptions(file);
        var dataWithUpdatedType = setTypeInBlob(file);
        if (file.name) {
          formPost.append(options.fieldName, dataWithUpdatedType, file.name);
        } else {
          formPost.append(options.fieldName, dataWithUpdatedType);
        }
      });
      return formPost;
    }
  }, {
    key: "install",
    value: function install() {
      if (this.opts.bundle) {
        var _this$uppy$getState2 = this.uppy.getState(),
          capabilities = _this$uppy$getState2.capabilities;
        this.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            individualCancellation: false
          })
        });
      }
      this.uppy.addUploader(_classPrivateFieldLooseBase(this, _handleUpload)[_handleUpload]);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (this.opts.bundle) {
        var _this$uppy$getState3 = this.uppy.getState(),
          capabilities = _this$uppy$getState3.capabilities;
        this.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            individualCancellation: true
          })
        });
      }
      this.uppy.removeUploader(_classPrivateFieldLooseBase(this, _handleUpload)[_handleUpload]);
    }
  }]);
  return XHRUpload;
}(BasePlugin);
export { XHRUpload as default };
function _uploadLocalFile2(_x4) {
  return _uploadLocalFile3.apply(this, arguments);
}
function _uploadLocalFile3() {
  _uploadLocalFile3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file) {
    var _this3 = this;
    var events, controller, uppyFetch;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          events = new EventManager(this.uppy);
          controller = new AbortController();
          uppyFetch = this.requests.wrapPromiseFunction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            var opts, fetch, body;
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  opts = _this3.getOptions(file);
                  fetch = _classPrivateFieldLooseBase(_this3, _getFetcher)[_getFetcher]([file]);
                  body = opts.formData ? _this3.createFormDataUpload(file, opts) : file.data;
                  return _context3.abrupt("return", fetch(opts.endpoint, _objectSpread(_objectSpread({}, opts), {}, {
                    body: body,
                    signal: controller.signal
                  })));
                case 4:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          })));
          events.onFileRemove(file.id, function () {
            return controller.abort();
          });
          events.onCancelAll(file.id, function (_ref) {
            var reason = _ref.reason;
            if (reason === 'user') {
              controller.abort();
            }
          });
          _context4.prev = 5;
          _context4.next = 8;
          return uppyFetch().abortOn(controller.signal);
        case 8:
          _context4.next = 14;
          break;
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](5);
          if (!(_context4.t0.message !== 'Cancelled')) {
            _context4.next = 14;
            break;
          }
          throw _context4.t0;
        case 14:
          _context4.prev = 14;
          events.remove();
          return _context4.finish(14);
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, this, [[5, 10, 14, 17]]);
  }));
  return _uploadLocalFile3.apply(this, arguments);
}
function _uploadBundle2(_x5) {
  return _uploadBundle3.apply(this, arguments);
}
function _uploadBundle3() {
  _uploadBundle3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(files) {
    var _this4 = this;
    var controller, uppyFetch, abort;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          abort = function _abort() {
            controller.abort();
          };
          controller = new AbortController();
          uppyFetch = this.requests.wrapPromiseFunction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
            var _this$uppy$getState$x, optsFromState, fetch, body;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  optsFromState = (_this$uppy$getState$x = _this4.uppy.getState().xhrUpload) != null ? _this$uppy$getState$x : {};
                  fetch = _classPrivateFieldLooseBase(_this4, _getFetcher)[_getFetcher](files);
                  body = _this4.createBundledUpload(files, _objectSpread(_objectSpread({}, _this4.opts), optsFromState));
                  return _context5.abrupt("return", fetch(_this4.opts.endpoint, _objectSpread(_objectSpread({}, _this4.opts), {}, {
                    body: body,
                    signal: controller.signal
                  })));
                case 4:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          })));
          // We only need to abort on cancel all because
          // individual cancellations are not possible with bundle: true
          this.uppy.once('cancel-all', abort);
          _context6.prev = 4;
          _context6.next = 7;
          return uppyFetch().abortOn(controller.signal);
        case 7:
          _context6.next = 13;
          break;
        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](4);
          if (!(_context6.t0.message !== 'Cancelled')) {
            _context6.next = 13;
            break;
          }
          throw _context6.t0;
        case 13:
          _context6.prev = 13;
          this.uppy.off('cancel-all', abort);
          return _context6.finish(13);
        case 16:
        case "end":
          return _context6.stop();
      }
    }, _callee6, this, [[4, 9, 13, 16]]);
  }));
  return _uploadBundle3.apply(this, arguments);
}
function _getCompanionClientArgs2(file) {
  var _file$remote;
  var opts = this.getOptions(file);
  var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields
  // Send along all fields by default.
  : Object.keys(file.meta);
  return _objectSpread(_objectSpread({}, (_file$remote = file.remote) == null ? void 0 : _file$remote.body), {}, {
    protocol: 'multipart',
    endpoint: opts.endpoint,
    size: file.data.size,
    fieldname: opts.fieldName,
    metadata: Object.fromEntries(allowedMetaFields.map(function (name) {
      return [name, file.meta[name]];
    })),
    httpMethod: opts.method,
    useFormData: opts.formData,
    headers: opts.headers
  });
}
function _uploadFiles2(_x6) {
  return _uploadFiles3.apply(this, arguments);
} // eslint-disable-next-line global-require
function _uploadFiles3() {
  _uploadFiles3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(files) {
    var _this5 = this;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Promise.allSettled(files.map(function (file) {
            if (file.isRemote) {
              var getQueue = function getQueue() {
                return _this5.requests;
              };
              var _controller = new AbortController();
              var removedHandler = function removedHandler(removedFile) {
                if (removedFile.id === file.id) _controller.abort();
              };
              _this5.uppy.on('file-removed', removedHandler);
              var uploadPromise = _this5.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase(_this5, _getCompanionClientArgs)[_getCompanionClientArgs](file), {
                signal: _controller.signal,
                getQueue: getQueue
              });
              _this5.requests.wrapSyncFunction(function () {
                _this5.uppy.off('file-removed', removedHandler);
              }, {
                priority: -1
              })();
              return uploadPromise;
            }
            return _classPrivateFieldLooseBase(_this5, _uploadLocalFile)[_uploadLocalFile](file);
          }));
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _uploadFiles3.apply(this, arguments);
}
XHRUpload.VERSION = packageJson.version;